export default __webpack_public_path__ + "static/media/kabur.121eabe0.gif";